import React from "react";

interface SortIndicatorProps {
  sortType: string;
}

export const SortIndicator: React.FC<SortIndicatorProps> = ({ sortType }) => {
  return (
    <div className="flex items-center justify-end">
      <span className="text-xs text-gray-600">{sortType}</span>
    </div>
  );
};
